import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import { LightenDarkenColor } from '../../utils/componentHelper';
import { GLOBAL } from '../../utils/constants';
import configContext from '../../utils/config';
// import { deepPurple, pink } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => {
  const { config } = React.useContext(configContext);
  return {
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
      '&:hover': {
        cursor: 'pointer',
      },
    },
    purple: {
      // color: theme.palette.getContrastText(deepPurple[500]),
      // backgroundColor: pink[50],
      color: theme.palette.KenColors.primary,
      backgroundColor:
        config?.customization?.palette?.activeStepBgColor ||
        `${LightenDarkenColor(
          theme.palette.KenColors.primary,
          GLOBAL.COLORS.SIDENAV.STEP_COLOR.RANGE
        )}`,
    },
  };
});

export default function LetterAvatars(props) {
  const classes = useStyles();
  const { firstName, lastName } = props;
  return (
    <div className={classes.root}>
      <Avatar className={classes.purple}>
        <Typography color='primary'>
          {firstName ? firstName[0].toUpperCase() : null}
          {lastName ? lastName[0].toUpperCase() : null}
        </Typography>
      </Avatar>
    </div>
  );
}
